import {
  Badge,
  ListItemButton,
  ListItemIcon,
  ListItemText,
  Tooltip,
} from '@mui/material'
import { TBasicListItem } from '../../../utils/types/layoutTypes'
import { useNavigate } from 'react-router-dom'
import { useNotificationCounterContext } from '../../../context/notificationsCounterContext/NotificationsCounterContextProvider'

const NotificationMenuList = ({
  index,
  selected,
  listItem,
  navMenuOpen,
}: TBasicListItem) => {
  const navigate = useNavigate()
  const { notificationsCounter } = useNotificationCounterContext()

  return (
    <Tooltip
      key={index}
      title={`${navMenuOpen ? '' : listItem.label}`}
      placement="right"
    >
      <ListItemButton
        selected={selected}
        onClick={() => navigate(listItem.goToUrl)}
      >
        <ListItemIcon sx={{ color: 'var(--white)' }}>
          {notificationsCounter > 0 ? (
            <Badge
              color="secondary"
              badgeContent={notificationsCounter}
              max={9}
            >
              {listItem.icon}
            </Badge>
          ) : (
            listItem.icon
          )}
        </ListItemIcon>

        <ListItemText primary={listItem.label} />
      </ListItemButton>
    </Tooltip>
  )
}

export default NotificationMenuList
